export const DIGITS = 6;
export const COOLDOWN_SECONDS = 60;